import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";

import { customFetchBase } from ".";

const reportsApi = createApi({
  reducerPath: REDUCER_PATHS.REPORTS,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    //admin Monitoring
    adminMonitoringListing: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADMIN_MONITORING_REPORT_LIST,
        body: data,
        method: "POST",
      }),
    }),
    adminReportDetailsDownload: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.DOWNLOAD_ADMIN_MONITORING_REPORT}/${data.type}?languageId=${data?.languageId}&filter=${data.filter}&column=${data.column}`,
        method: "GET",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),

    //super admin User Report
    superAdminUserReportListing: builder.mutation({
      query: (data) => ({
        url: apiConfig.SUPER_ADMIN_USER_REPORT_LIST,
        body: data,
        method: "POST",
      }),
    }),
    superAdminUserReportDownload: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.DOWNLOAD_SUPER_ADMIN_USER_REPORT}/${data.type}?languageId=${data?.languageId}&filter=${data.filter}&column=${data.column}`,
        method: "GET",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),

    //super admin Club Report
    superAdminClubReportListing: builder.mutation({
      query: (data) => ({
        url: apiConfig.SUPER_ADMIN_CLUB_REPORT_LIST,
        body: data,
        method: "POST",
      }),
    }),
    superAdminClubReportDownload: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.DOWNLOAD_SUPER_ADMIN_CLUB_REPORT}/${data.type}?languageId=${data?.languageId}&filter=${data.filter}&column=${data.column}`,
        method: "GET",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),

    //super admin brand  Report
    superAdminBrandReportListing: builder.mutation({
      query: (data) => ({
        url: apiConfig.SUPER_ADMIN_BRAND_REPORT_LIST,
        body: data,
        method: "POST",
      }),
    }),
    superAdminBrandReportDownload: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.DOWNLOAD_SUPER_ADMIN_BRAND_REPORT}/${data.type}?languageId=${data?.languageId}&filter=${data.filter}&column=${data.column}`,
        method: "GET",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),

    //club admin
    clubAdminUserReportListing: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_ADMIN_USER_REPORT_LIST,
        body: data,
        method: "POST",
      }),
    }),
    clubAdminUserReportDownload: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.DOWNLOAD_CLUB_ADMIN_USER_REPORT}/${data.type}?languageId=${data?.languageId}&filter=${data.filter}&column=${data.column}`,
        method: "GET",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),

    //brand admin
    brandAdminUserReportListing: builder.mutation({
      query: (data) => ({
        url: apiConfig.BRAND_ADMIN_USER_REPORT_LIST,
        body: data,
        method: "POST",
      }),
    }),
    brandAdminUserReportDownload: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.DOWNLOAD_BRAND_ADMIN_USER_REPORT}/${data.type}?languageId=${data?.languageId}&filter=${data.filter}&column=${data.column}`,
        method: "GET",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
  }),
});

export const {
  useBrandAdminUserReportListingMutation,
  useBrandAdminUserReportDownloadMutation,
  //user
  useSuperAdminUserReportListingMutation,
  useSuperAdminUserReportDownloadMutation,
  //club
  useSuperAdminClubReportDownloadMutation,
  useSuperAdminClubReportListingMutation,
  //brand
  useSuperAdminBrandReportDownloadMutation,
  useSuperAdminBrandReportListingMutation,
  //club admin
  useClubAdminUserReportListingMutation,
  useClubAdminUserReportDownloadMutation,

  useAdminMonitoringListingMutation,
  useAdminReportDetailsDownloadMutation,
} = reportsApi;

export default reportsApi;
